import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import { Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl } from 'state/reducers/translation.reducers';
import { getShowPlanSelectedNotification, setShowPlanSelectionNotification } from 'state/reducers/user.reducers';

export type Props = {
	text: string;
	imageKey: string;
};

export default function InfoStrip(props: Props) {
	const theme = useTheme();
	const imageUrl = useAppSelector(selectImageUrl);
	const showNotification = useAppSelector(getShowPlanSelectedNotification);
	const dispatch = useAppDispatch();

	return (
		<Box sx={{ width: '100%' }}>
			<Collapse in={showNotification}>
				<Box
					sx={{
						height: '48px',
						padding: '8px 20px 8px 32px',
						overflow: 'hidden!important',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						borderRadius: 0,
						background: theme.palette.root.brandSecondary,
						color: theme.palette.root.basicWhite,
					}}
				>
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						<img src={imageUrl(props.imageKey) || '/icons/celebrate.svg'} alt="Celebrate" />
						<Typography variant="alertBody" sx={{ marginLeft: '8px' }}>
							{props.text}
						</Typography>
					</Box>
					<IconButton
						onClick={() => {
							dispatch(setShowPlanSelectionNotification(false));
						}}
						sx={{
							width: '32px',
							height: '32px',
							borderRadius: '8px',
							background: theme.palette.root.brandSecondary,
							'&:hover': { backgroundColor: theme.palette.root.basicWhite_007 },
						}}
					>
						<CloseIcon
							sx={{
								color: theme.palette.root.basicWhite,
								width: '24px',
							}}
						/>
					</IconButton>
				</Box>
			</Collapse>
		</Box>
	);
}
